import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, Requisition } from "@/types";

export function useDuplicateRequisition() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({ requisitionId }: { requisitionId: number }) => {
      const path = `jobs/${currentJobId.toString()}/requisitions/${requisitionId.toString()}/duplicate`;
      const res = await guacHttpClient.post<
        Requisition,
        HttpResponse<Requisition>
      >(path);

      return res.data;
    },
    onSuccess: () => {
      // Invalidate queries that have job intake
      void queryClient.invalidateQueries({
        queryKey: ["jobs", currentCompanyId],
      });
    },
  });

  return mutation;
}
